export default function(str, data) {
  return str.replace(/\{\{(.*?)\}\}/g, (match, token) => (data[token] ? data[token] : ''));
}
